export const policyIcon = (policyNumber) => {
	const type = policyNumber.substring(0, 3);
	switch (type) {
		case 'PPA':
			return 'car';
		case 'HOM':
		case 'PIM':
		case 'PUP':
		case 'DFR':
			return 'home';
		case 'FAR':
		case 'FUP':
			return 'barn';
		default:
			return 'open-sign';
	}
};

export const printUrl = (url) => {
	return `${window.location.origin}/api/document?q=${url}`;
};
